import Button from '@mui/material/Button';
import {useSession, signOut} from "next-auth/react"
import {Stack} from "@mui/material";
import {useTranslation} from "react-i18next";
import {navMap} from '../../nav/navMap';
import {useRouter} from "next/navigation";



const SignIn = ({label, currentLocale, router}) => {
    return (
        <Button color="secondary" variant="text" onClick={() => {
            router.push(navMap.locale(currentLocale).login())
        }}>
            {label}
        </Button>);
};

const SignOut = ({label, currentLocale}) => {
    return <Button color="secondary" variant="text" onClick={() => signOut({
        redirectTo: navMap.locale(currentLocale).signedOut()
    })}>
        {label}
    </Button>
}


export default function LoginButton() {
    const {t, i18n} = useTranslation("common");
    const currentLocale = i18n.language;
    const router = useRouter();

    const session = useSession();
    if(session) {
        const sessionData = session.data;
        if (sessionData && sessionData.user) {
            return (
                <Stack direction={"row"} justifyContent={"center"} alignItems={"center"} gap={1}>
                    <SignOut label={t("header.login.sign-out-button-label")} currentLocale={currentLocale}/>
                </Stack>
            )
        }
    }
    return (
        <Stack direction={"row"} justifyContent={"center"} alignItems={"center"} gap={1}>
            <SignIn router={router} label={t("header.login.sign-in-button-label")} currentLocale={currentLocale}/>
        </Stack>
    )
}